import { render } from "./SettingsCard.vue?vue&type=template&id=02ae4bb2&scoped=true"
import script from "./SettingsCard.vue?vue&type=script&lang=js"
export * from "./SettingsCard.vue?vue&type=script&lang=js"

import "./SettingsCard.vue?vue&type=style&index=0&id=02ae4bb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ae4bb2"]])

export default __exports__